import { render, staticRenderFns } from "./JobCard.vue?vue&type=template&id=65e753f5&scoped=true&"
import script from "./JobCard.vue?vue&type=script&lang=js&"
export * from "./JobCard.vue?vue&type=script&lang=js&"
import style0 from "./JobCard.vue?vue&type=style&index=0&id=65e753f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e753f5",
  null
  
)

export default component.exports